import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

interface IProps extends IForm<any> {}

const Contact = (props: IProps) => {
  const { setFocus } = props;
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field label='E-mail' name='contacts_email' id='contacts_email' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Telefone' name='contacts_phone' id='contacts_phone' mask={'phone'} onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Facebook' name='contacts_facebook' id='contacts_facebook' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Skype' name='contacts_skype' id='contacts_skype' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field id='show_contact_info' name='show_contact_info' label='Tornar informação de contato público ?' component={SwitchFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field id='show_contact_to_producer' name='show_contact_to_producer' label='Exibir e-mail para produtor ?' component={SwitchFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field id='show_messenger' name='show_messenger' label='Exibir mensageria com cliente ?' component={SwitchFormField} />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Contact;
